export const rejectMarkOption = [
    {
        label: '平台初审驳回',
        value: "00"
    },
    {
        label: '平台复核驳回',
        value: "01"
    },
    {
        label: '门店打款驳回',
        value: "02"
    },
    {
        label: '门店审核驳回',
        value: "03"
    },
    {
        label: '回收商撤回申请',
        value: "04"
    }
]

export const formItemList = [
    {slotName:"operationSelect"},
    {
        labelName: "订单编号",
        key: 'orderNo',
        type: "input",
        lableWidth: "80px",
        placeholder: "请输入订单编号",
    },
    {
        labelName: "串号",
        key: 'imei',
        type: "input",
        lableWidth: "43px",
        placeholder: "请输入串号查询",
    },
    {
        labelName: "绑定条码",
        key: 'barCode',
        type: "input",
        lableWidth: "80px",
        placeholder: "请输入绑定条码",
    },
    // {
    //     labelName: "外部订单号",
    //     key: 'outOrderNo',
    //     type: "input",
    //     lableWidth: "90px",
    //     placeholder: "请输入查询",
    // },
    // {
    //     labelName: "回收商家",
    //     key: 'merchantId',
    //     type: "selectFilterable",
    //     placeholder: "请选择",
    //     lableWidth: '80px',
    //     clear: true,
    //     option: [],
    //     clearFun: () => false
    // },
    {
        labelName: "询价商家",
        key: 'companyId',
        childrenKey: "storeId",
        type: "selectFilterable",
        placeholder: "请选择",
        lableWidth: '80px',
        clear: true,
        option: [],
        clearFun: () => false
    },
    // 新加-订单状态
    {
        key: 'orderState',
        type: 'select',
        lableWidth: '98px',
        placeholder: "请选择订单状态",
        labelName: '订单状态',
        option: [
            {
                label: '待确认',
                value: '00'
            },
            {
                label: '已确认',
                value: '01'
            },
            {
                label: '待支付',
                value: "02"
            },
            {
                label: '已绑码',
                value: "03"
            },
            {
                label: '已收货',
                value: "04"
            },
            {
                label: '降价收货',
                value: "05"
            },
            {
                label: '已取消',
                value: "10"
            },
            {
                label: '已作废',
                value: "20"
            },
            {
                label: '已退回',
                value: "30"
            },
        ],
    },
    {
        key: "phoneName",
        type: "input",
        labelName: "回收商品",
        placeholder: "请输入商品名称",
    },
    {
        key: "typeId",
        type: "select",
        labelName: "回收分类",
        placeholder: "请选择分类",
        option: [],
    },
    {
        key: 'isEnablePay',
        type: 'select',
        lableWidth: '98px',
        placeholder: "请选择",
        labelName: '是否线上支付',
        option: [
            {
                label: '全部',
                value: null
            },
            {
                label: '是',
                value: true
            },
            {
                label: '否',
                value:false
            }
        ],
    },
    { slotName: 'applyAmount' },
    { slotName: 'catalogId' },
    { slotName: 'itemId' },
    {
        lableWidth: "80px",
        labelName: "下单时间",
        key: 'createTime',
        type: "daterange",
    },
    {
        lableWidth: "80px",
        labelName: "成交时间",
        key: 'ackTime',
        type: "daterange",
    },
    {
        lableWidth: "80px",
        labelName: "申请时间",
        key: 'applyTime',
        type: "daterange",
    },
    {
        lableWidth: "80px",
        labelName: "初审时间",
        key: 'auditFirstTime',
        type: "daterange",
    },
    {
        lableWidth: "80px",
        labelName: "打款时间",
        key: 'payTime',
        type: "daterange",
    },
    {
        lableWidth: "80px",
        labelName: "关闭时间",
        key: 'closeTime',
        type: "daterange",
    },
    {
        labelName: "关闭原因",
        key: 'rejectMark',
        type: "selectFilterable",
        placeholder: "请选择",
        lableWidth: '80px',
        clear: true,
        option: rejectMarkOption,
        clearFun: () => false
    },
    // 打款方式
    {
        key: 'moneyWay',
        type: 'select',
        lableWidth: '98px',
        placeholder: "请选择",
        labelName: '打款方式',
        option: [
            {
                label: '线上打款',
                value: '01'
            },
            {
                label: '线下打款',
                value: "00"
            }
        ],
    },
]

export const tabData = [
    {
        text: "待审核",
        value: "00",
        num: 0,
        key: "waitPNum"
    },
    {
        text: "待打款",
        value: "G01",
        num: 0,
        key: "waitPayNum"
    },
    // {
    //     text: "待门店打款",
    //     value: "02",
    //     num: 0,
    //     key: "waitCompanyPayNum",
    //     staState: '00' //00：无暂存，01：暂存
    // },
    {
        text: "追差完成",
        value: "04",
        num: 0,
        key: "finishNum"
    },
    {
        text: "追差关闭",
        value: "G10",
        num: 0,
        key: "closeNum"
    },
    // {
    //     text: "暂存订单",
    //     value: "",
    //     num: 0,
    //     key: "temporaryNum",
    //     staState: '01' //00：无暂存，01：暂存
    // }
]

export const tableData = {
    loading: false,
    // 当前数据
    currentData: {},
    // 表数据
    data: [],
    // 表列
};

// 表列
export const platformTableColumns = [
    {
        prop: "images",
        label: "旧机照片",
    },
    // {
    //     prop: "phoneName",
    //     label: "机型",
    // },
    {
        prop: "phoneName",
        label: "回收商品",
    },
    {
        prop: "imei",
        label: "旧机串号",
    },
    {
        prop: "typeName",
        label: "分类-品牌",
    },
    {
        prop: "createCompanyName",
        label: "询价商家",
    },
    {
        prop: "orderTime",
        label: "下单时间",
    },
    {
        prop: "quoteStaffInfo",
        label: "报价师",
    },
    {
        prop: "barCode",
        label: "绑定条码",
    },
    // {
    //     prop: "createCompanyName",
    //     label: "门店商户",
    // },
    // {
    //     prop: "createStoreName",
    //     label: "下单门店",
    // },
    // {
    //     prop: "createStaffInfo",
    //     label: "下单店员",
    // },
    // {
    //     prop: "quoteMerchants",
    //     label: "参与报价回收商",
    // },
    {
        prop: "orderState",
        label: "订单状态",
    },
    {
        prop: "manualQuotePrice",
        label: "成交金额",
    },
    {
        prop: "isOnlinePay",
        label: "支付方式",
    },
    // {
    //     prop: "applyStaffInfo",
    //     label: "申请人",
    // },
    // {
    //     prop: "manualQuotePrice",
    //     label: "回收金额(含差异基金)"
    // },
    {
        prop: "items",
        label: "追差内容",
    },
    {
        prop: "arguePrice",
        label: "申请追差金额",
    },
    // {
    //     prop: "auditFirstInfo",
    //     label: "初审时间",
    //     // 控制是否隐藏当前
    //     isHide: true,
    // },
    {//待打款的
        prop: "auditPrice",
        label: "审核通过金额",
        // 控制是否隐藏当前
        isHide: true
    },
    {//追差完成的
        prop: "payTime",
        label: "打款时间",
        // 控制是否隐藏当前
        isHide: true,
    },
    {//追差完成的
        prop: "canArguePrice",
        label: "实际追差金额",
        // 控制是否隐藏当前
        isHide: true
    },
    {
        prop: "rejectMarkText",
        label: "关闭原因",
        // 控制是否隐藏当前
        isHide: true
    },
    {
        prop: 'closeInfo',
        label: "操作人",
        isHide: true
    },
    {
        prop: "closeTime",
        label: "关闭时间",
        // 控制是否隐藏当前
        isHide: true
    },
    // 暂存订单 新增 ***
    // {
    //     prop: "staAdminName",
    //     label: "暂存人",
    //     // 控制是否隐藏当前
    //     isHide: true
    // },
    // {
    //     prop: "staTime",
    //     label: "暂存时间",
    //     // 控制是否隐藏当前
    //     isHide: true
    // },
    // {
    //     prop: "staCause",
    //     label: "暂存原因",
    //     // 控制是否隐藏当前
    //     isHide: true
    // },
    // 备注
    // {
    //     prop: "noteNum",
    //     width: '180px',
    //     label: "备注"
    // },
    // ***
    {
        prop: "action",
        width: '200px',
        label: "操作"
    }
]

// 责任列表
export const responsibilityData = [
    {
        label: "门店责任",
        value: "C"
    },
    {
        label: "回收商责任(驳回追差)",
        value: "M"
    },
    {
        label: "双方共同责任",
        value: "T"
    },
]

//责任切换弹窗提示
export const switchResponsibility = {
    title: '切换提示',
    show: false,
    isTip: true,
    tipText: '切换选项会清空已填写的信息，是否确认继续操作？',
    newValue: '',
}


//确认扣款余额设置
export const deBalanceVoucherProps = {
    title: "确认扣款商户余额",
    show: false,
    headerMessage: "说明：请谨慎确认追差款项从商户余额扣款，并上传沟通凭证",
    isView: false//是否只是查看
}

export const photoDialogProp = {
    show: false,
    photoArr: []
}


// 驳回差异
export const rejectProp = {
    show: false,
    title: '驳回差异',
    currentData: {},
    headerMessage: "说明：驳回差异默认回收商责任，需重新填写判责依据，确认驳回后将推送给回收商",
    judgements: [],
    isReset: false,
}
//初审判责依据
export const firstRejectProp = {
    show:false,
    title:"初审判责依据",
    judgements: [],
    rejectText:"",
    tabSquare:"01",
    assignmentData:[],
    undertakeSubject:"",
    sourceData:[],
}
